import React, { createContext, useState, useContext, useCallback, useRef } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const loadingTimer = useRef(null);

  const showLoading = useCallback(() => {
    if (loadingTimer.current) {
      clearTimeout(loadingTimer.current);
    }
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    if (loadingTimer.current) {
      clearTimeout(loadingTimer.current);
    }
    setIsLoading(false);
  }, []);

  const showLoadingWithDelay = useCallback((delay = 2000) => {
    loadingTimer.current = setTimeout(() => {
      setIsLoading(true);
    }, delay);
  }, []);

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading, showLoadingWithDelay }}>
      {children}
      {isLoading && <LoadingSpinner />}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};